namespace advisorop.components.servicer {

    export class CashDistributionsController {
        cashDistributionsDetails: Array<any>;
        advisoryFirmId: number;
        depWdChoice: number; // 0 = Withdrawals, 1 = Deposits
        pageLen: number;
        issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;

        // grid instance
        dgCashDistributions: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#cashDistributionsContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "CashDistributions"
                },
                bindingOptions: {
                    dataSource: "vm.cashDistributionsDetails",
                },
                //height: 400,
                width: '100%',
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgCashDistributions = e.component;
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "nextDistDate", caption: "Next Dist Date", width: 70, dataType: "datetime", format: "shortDate", sortIndex: 0, sortOrder: "asc" },
                    { dataField: "householdName", caption: "Household", width: 125, sortIndex: 1, sortOrder: "asc" },
                    { dataField: "accountNumber", caption: "Account Number", width: 73 },
                    { dataField: "custodianName", caption: "Custodian", width: 80 },
                    { dataField: "accountName", caption: "Account Name", width: 125 },
                    { dataField: "accountValue", caption: "Account Value", format: "currency", width: 65 },
                    { dataField: "pretaxAmt", caption: "Pre-Tax Amt", format: "currency", width: 65 },
                    { dataField: "fedWithholdingAmt", caption: "Fed With.", format: "currency", width: 50 },
                    { dataField: "stateWithholdingAmt", caption: "State With.", format: "currency", width: 50 },
                    { dataField: "netAmt", caption: "Net Amt", format: "currency", width: 65 },
                    { dataField: "cashBalance", caption: "Cash Balance", format: "currency", width: 65 },
                    { dataField: "excessShortfall", caption: "Excess/ Shortfall", format: "currency", width: 60 },
                    { dataField: "frequency", caption: "Freq", alignment: "center", width: 80 },
                    { dataField: "assetMoveMethod", caption: "Method", width: 125 },
                    { dataField: "assetMoveType", caption: "Type", width: 40 },
                    { dataField: "endDate", caption: "Instr End", width: 70, dataType: "datetime", format: "shortDate" },
                    { dataField: "startDate", caption: "Instr Start", width: 70, dataType: "datetime", format: "shortDate" }
                    ],
                masterDetail: {
                    enabled: true,
                    template: "sleeves",
                    autoExpandAll: false
                },
                onCellPrepared: (e: any) => {

                    if (e.rowType === 'data') {
                        if (e.column.command === 'expand') {
                            if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                                e.cellElement.removeClass('dx-datagrid-expand');
                                e.cellElement.empty();
                            }
                        }

                        // Withdrawals, color code excess vs shortfall
                        if (this.depWdChoice == 0 && e.columnIndex === 12) {
                            e.cellElement.css('color', (e.value >= 0) ? "green" : "red");
                        }
                    }
                },
                onContentReady: (e) => {

                    // We always show closed / inactive in RTG dash because it inclused performance of accounts
                    if (this.depWdChoice == 1) { // 0 = Withdrawals, 1 = Deposits
                        e.component.columnOption("pretaxAmt", "visible", false);
                        e.component.columnOption("fedWithholdingAmt", "visible", false);
                        e.component.columnOption("stateWithholdingAmt", "visible", false);
                        e.component.columnOption("excessShortfall", "visible", false);
                    } else {
                        e.component.columnOption("pretaxAmt", "visible", true);
                        e.component.columnOption("fedWithholdingAmt", "visible", true);
                        e.component.columnOption("stateWithholdingAmt", "visible", true);
                        e.component.columnOption("excessShortfall", "visible", true);
                    }

                    this.isInitializing = false;
                }
            };
        }

        oncp = function (e: any) {
        }

        onChangeDepWd() {
            this.loadCashDistributions();
        };

        loadCashDistributions() {

            this.mvDate = null;

            let rez: any;

            this.isInitializing = true;

            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                //console.log("Loading cash monitor data for firm: " + this.advisoryFirmId);
                rez = this.servicerService.getCashDistributionsData(this.advisoryFirmId, this.depWdChoice);
            }

            rez.then(response => {
                this.cashDistributionsDetails = response.data;
                //console.log("CashMonitorDetails:",this.cashMonitorDetails);
                if (this.cashDistributionsDetails.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    //this.mvDate = this.cashMonitorDetails[0].details.marketValueDate;
                    if (this.depWdChoice == 0) {   // Only update error count associated with withdrawals
                        var issues = this.cashDistributionsDetails.filter(w => (w.cashBalance - w.netAmt < 0));
                        this.issuesCount = issues.length;
                    } else {
                        let todayDate = new Date();
                        this.cashDistributionsDetails.forEach((e) => {
                            var d = new Date(e.nextDistDate);
                            if (d.getDate() == todayDate.getDate()
                                && d.getMonth() == todayDate.getMonth()
                                && d.getFullYear() == todayDate.getFullYear()) {
                                this.issuesCount++;
                            }
                        });
                    }
                }
                //this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadCashDistributions();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.cashMonitorDetails);
                //}
            }
        };
    }


    class CashDistributions implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                depWdChoice: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = CashDistributionsController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cash-distributions.html";
        }
    }
    angular.module(Constants.APP).component("cashDistributions", new CashDistributions());

}